import { translateFn } from '../../../utils/translator.helper';

export enum Column {
  SCHEDULE_NAME,
  SCHEDULE_TYPE,
  STATUS,
  SCHEDULE_DETAILS,
  LAST_MODIFIED_DATE,
  LAST_EDITED_BY,
  IN_POLICIES,
  CATEGORIES_AFFECTED,
  PERMISSIONS,
}

export enum ColumnKeys {
  SCHEDULE_NAME = 'name',
  SCHEDULE_TYPE = 'type',
  STATUS = 'status',
  SCHEDULE_DETAILS = 'subschedules',
  LAST_MODIFIED_DATE = 'updated.date',
  LAST_EDITED_BY = 'updated.userName',
  IN_POLICIES = 'inPoliciesCount',
  CATEGORIES_AFFECTED = 'subschedules.categories',
  PERMISSIONS = 'allowChangeByOtherUsers',
}

export enum ScheduleGridEvents {
  CLICK_ON_SCHEDULE_NAME = 'clickOnScheduleName',
  CLICK_ON_IN_POLICIES = 'clickOnInPolicies',
  REFRESH_COMPONENT = 'refreshScheduleComponent',
  SAVE_SCHEDULE = 'saveSchedule',
}

export interface EnumValues {
  label: string;
  value: number;
}

export enum StatusType {
  UNUSED = 1,
  USED = 2,
}

export enum ActionType {
  ALLOW = 1,
  BLOCK = 2,
  WARN = 3,
}

export enum WebCategory {
  WEB_ACCESS_CATEGORY_WEB_PROXY = 0,
  WEB_ACCESS_CATEGORY_GAMES = 1,
  WEB_ACCESS_CATEGORY_TABLOIDS = 2,
  WEB_ACCESS_CATEGORY_HATE = 3,
  WEB_ACCESS_CATEGORY_GAMBLING = 4,
  WEB_ACCESS_CATEGORY_ILLEGAL = 6,
  WEB_ACCESS_CATEGORY_SHOPPING = 7,
  WEB_ACCESS_CATEGORY_ONLINE_PAY = 8,
  WEB_ACCESS_CATEGORY_VIDEO = 9,
  WEB_ACCESS_CATEGORY_SOCIAL_NETWORK = 10,
  WEB_ACCESS_CATEGORY_ONLINE_DATING = 11,
  WEB_ACCESS_CATEGORY_IM = 12,
  WEB_ACCESS_CATEGORY_SEARCH_ENGINES = 13,
  WEB_ACCESS_CATEGORY_NEWS = 15,
  WEB_ACCESS_CATEGORY_PORNOGRAPHY = 16,
  WEB_ACCESS_CATEGORY_MATURE_CONTENT = 17,
  WEB_ACCESS_CATEGORY_BLOG = 18,
  WEB_ACCESS_CATEGORY_FILE_SHARING = 19,
  WEB_ACCESS_CATEGORY_NARCOTICS = 20,
  WEB_ACCESS_CATEGORY_VIDEO_ONLINE = 21,
  WEB_ACCESS_CATEGORY_RELIGIOUS = 32,
  WEB_ACCESS_CATEGORY_SUICIDE = 33,
  WEB_ACCESS_CATEGORY_HEALTH = 34,
  WEB_ACCESS_CATEGORY_WEAPONS = 36,
  WEB_ACCESS_CATEGORY_HACKING = 37,
  WEB_ACCESS_CATEGORY_SCAMS = 38,
  WEB_ACCESS_CATEGORY_PHOTOS_ONLINE = 42,
  WEB_ACCESS_CATEGORY_ADS = 43,
  WEB_ACCESS_CATEGORY_ADVICE = 44,
  WEB_ACCESS_CATEGORY_BANK = 45,
  WEB_ACCESS_CATEGORY_BUSINESS = 46,
  WEB_ACCESS_CATEGORY_COMPUTER_AND_SOFTWARE = 47,
  WEB_ACCESS_CATEGORY_EDUCATION = 48,
  WEB_ACCESS_CATEGORY_ENTERTAINMENT = 49,
  WEB_ACCESS_CATEGORY_GOVERNMENT = 50,
  WEB_ACCESS_CATEGORY_HOBBIES = 51,
  WEB_ACCESS_CATEGORY_HOSTING = 52,
  WEB_ACCESS_CATEGORY_JOB_SEARCH = 53,
  WEB_ACCESS_CATEGORY_PORTALS = 54,
  WEB_ACCESS_CATEGORY_RADIO_MUSIC = 55,
  WEB_ACCESS_CATEGORY_SPORTS = 56,
  WEB_ACCESS_CATEGORY_TIME_WASTERS = 57,
  WEB_ACCESS_CATEGORY_TRAVEL = 58,
  WEB_ACCESS_CATEGORY_WEB_MAIL = 59,
  WEB_ACCESS_CATEGORY_ALCOHOL = 64,
  WEB_ACCESS_CATEGORY_TOBACCO = 65,
  WEB_ACCESS_CATEGORY_PHARMACY = 66,
  WEB_ACCESS_CATEGORY_AUTO = 67,
  WEB_ACCESS_CATEGORY_ASTROLOGY = 68,
  WEB_ACCESS_CATEGORY_FOOD = 69,
  WEB_ACCESS_CATEGORY_KIDS = 70,
  WEB_ACCESS_CATEGORY_LIFE_STYLE = 71,
  WEB_ACCESS_CATEGORY_OCCULT = 72,
  WEB_ACCESS_CATEGORY_PETS = 73,
  WEB_ACCESS_CATEGORY_REAL_ESTATE = 74,
  WEB_ACCESS_CATEGORY_SOCIETY = 75,
}

export function getAllWebCategoryLabels(): Record<WebCategory | number, string> {
  return {
    [WebCategory.WEB_ACCESS_CATEGORY_WEB_PROXY]: translateFn("Web Proxy"),
    [WebCategory.WEB_ACCESS_CATEGORY_GAMES]: translateFn("Games"),
    [WebCategory.WEB_ACCESS_CATEGORY_TABLOIDS]: translateFn("Tabloids"),
    [WebCategory.WEB_ACCESS_CATEGORY_HATE]: translateFn("Hate"),
    [WebCategory.WEB_ACCESS_CATEGORY_GAMBLING]: translateFn("Gambling"),
    [WebCategory.WEB_ACCESS_CATEGORY_ILLEGAL]: translateFn("Software Piracy"),
    [WebCategory.WEB_ACCESS_CATEGORY_SHOPPING]: translateFn("Online Shopping"),
    [WebCategory.WEB_ACCESS_CATEGORY_ONLINE_PAY]: translateFn("Online Payment"),
    [WebCategory.WEB_ACCESS_CATEGORY_VIDEO]: translateFn("Videos"),
    [WebCategory.WEB_ACCESS_CATEGORY_SOCIAL_NETWORK]: translateFn("Social Networks"),
    [WebCategory.WEB_ACCESS_CATEGORY_ONLINE_DATING]: translateFn("Online Dating"),
    [WebCategory.WEB_ACCESS_CATEGORY_IM]: translateFn("IM"),
    [WebCategory.WEB_ACCESS_CATEGORY_SEARCH_ENGINES]: translateFn("Search Engines"),
    [WebCategory.WEB_ACCESS_CATEGORY_NEWS]: translateFn("News"),
    [WebCategory.WEB_ACCESS_CATEGORY_PORNOGRAPHY]: translateFn("Pornography"),
    [WebCategory.WEB_ACCESS_CATEGORY_MATURE_CONTENT]: translateFn("Mature Content"),
    [WebCategory.WEB_ACCESS_CATEGORY_BLOG]: translateFn("Blogs"),
    [WebCategory.WEB_ACCESS_CATEGORY_FILE_SHARING]: translateFn("File Sharing"),
    [WebCategory.WEB_ACCESS_CATEGORY_NARCOTICS]: translateFn("Narcotics"),
    [WebCategory.WEB_ACCESS_CATEGORY_RELIGIOUS]: translateFn("Religion"),
    [WebCategory.WEB_ACCESS_CATEGORY_SUICIDE]: translateFn("Suicide"),
    [WebCategory.WEB_ACCESS_CATEGORY_HEALTH]: translateFn("Health"),
    [WebCategory.WEB_ACCESS_CATEGORY_WEAPONS]: translateFn("Weapons"),
    [WebCategory.WEB_ACCESS_CATEGORY_HACKING]: translateFn("Hacking"),
    [WebCategory.WEB_ACCESS_CATEGORY_SCAMS]: translateFn("Scams"),
    [WebCategory.WEB_ACCESS_CATEGORY_PHOTOS_ONLINE]: translateFn("Online Photo"),
    [WebCategory.WEB_ACCESS_CATEGORY_ADS]: translateFn("Ads"),
    [WebCategory.WEB_ACCESS_CATEGORY_ADVICE]: translateFn("Advice"),
    [WebCategory.WEB_ACCESS_CATEGORY_BANK]: translateFn("Financial"),
    [WebCategory.WEB_ACCESS_CATEGORY_BUSINESS]: translateFn("Business"),
    [WebCategory.WEB_ACCESS_CATEGORY_COMPUTER_AND_SOFTWARE]: translateFn("Computers and Software"),
    [WebCategory.WEB_ACCESS_CATEGORY_EDUCATION]: translateFn("Education"),
    [WebCategory.WEB_ACCESS_CATEGORY_ENTERTAINMENT]: translateFn("Entertainment"),
    [WebCategory.WEB_ACCESS_CATEGORY_GOVERNMENT]: translateFn("Government"),
    [WebCategory.WEB_ACCESS_CATEGORY_HOBBIES]: translateFn("Hobbies"),
    [WebCategory.WEB_ACCESS_CATEGORY_HOSTING]: translateFn("Hosting"),
    [WebCategory.WEB_ACCESS_CATEGORY_JOB_SEARCH]: translateFn("Job Search"),
    [WebCategory.WEB_ACCESS_CATEGORY_PORTALS]: translateFn("Portals"),
    [WebCategory.WEB_ACCESS_CATEGORY_RADIO_MUSIC]: translateFn("Radio Music"),
    [WebCategory.WEB_ACCESS_CATEGORY_SPORTS]: translateFn("Sports"),
    [WebCategory.WEB_ACCESS_CATEGORY_TIME_WASTERS]: translateFn("Time Wasters"),
    [WebCategory.WEB_ACCESS_CATEGORY_TRAVEL]: translateFn("Travel"),
    [WebCategory.WEB_ACCESS_CATEGORY_WEB_MAIL]: translateFn("Web Mail"),
    [WebCategory.WEB_ACCESS_CATEGORY_ALCOHOL]: translateFn("Alcohol"),
    [WebCategory.WEB_ACCESS_CATEGORY_TOBACCO]: translateFn("Tobacco"),
    [WebCategory.WEB_ACCESS_CATEGORY_PHARMACY]: translateFn("Pharmacy"),
    [WebCategory.WEB_ACCESS_CATEGORY_AUTO]: translateFn("Auto"),
    [WebCategory.WEB_ACCESS_CATEGORY_ASTROLOGY]: translateFn("Astrology"),
    [WebCategory.WEB_ACCESS_CATEGORY_FOOD]: translateFn("Food"),
    [WebCategory.WEB_ACCESS_CATEGORY_KIDS]: translateFn("Kids"),
    [WebCategory.WEB_ACCESS_CATEGORY_LIFE_STYLE]: translateFn("Life Style"),
    [WebCategory.WEB_ACCESS_CATEGORY_OCCULT]: translateFn("Occult"),
    [WebCategory.WEB_ACCESS_CATEGORY_PETS]: translateFn("Pets"),
    [WebCategory.WEB_ACCESS_CATEGORY_REAL_ESTATE]: translateFn("Real Estate"),
    [WebCategory.WEB_ACCESS_CATEGORY_SOCIETY]: translateFn("Society"),
  };
}

export function getAllStatusTypeLabels(): Record<StatusType | number, string> {
  return {
    [StatusType.UNUSED]: translateFn("Unused"),
    [StatusType.USED]: translateFn("Used"),
  };
}

export function getActionLabels(): Record<StatusType | number, string> {
  return {
    [ActionType.ALLOW]: translateFn("Allow"),
    [ActionType.BLOCK]: translateFn("Block"),
    [ActionType.WARN]: translateFn("Warn"),
  };
}

export function getWebCategoryLabel(webCategory: WebCategory): string {
  const webCategoryLabels: Record<WebCategory | number, string> = getAllWebCategoryLabels();
  return typeof webCategoryLabels[webCategory] !== "undefined" ?  webCategoryLabels[webCategory] : '';
}

export function getWebCategoriesLabels(webCategory: Array<WebCategory>): Array<string> {
  const categories = webCategory.map(category => getWebCategoryLabel(category));
  return categories.filter((value, index, array) => {
    return array.indexOf(value) === index && value;
  });
}

export function getStatusTypeLabel(statusType: StatusType): string {
  const statusTypeLabels: Record<StatusType | number, string> = getAllStatusTypeLabels();
  return typeof statusTypeLabels[statusType] !== "undefined" ?  statusTypeLabels[statusType] : '';
}

export enum Permissions {
  NOT_SHARED = 0,
  SHARED = 1,
}

export function getAllPermissionsLabels(): Record<Permissions, string> {
  return {
    [Permissions.NOT_SHARED]: translateFn("Not Shared"),
    [Permissions.SHARED]: translateFn("Shared"),
  };
}
